import { WorkflowStep } from "./workflow-step";
import { WorkflowFile } from "./workflow-file";
import { WorkflowAutoEmail } from "./workflow-auto-email";
import { WorkflowAutoUpload } from "./workflow-auto-upload";
import { WorkflowForm } from './workflow-form';
import { WorkflowAutoStart } from "./workflow-auto-start";
import { ConnectedAppAuth } from "./connected-app";

export interface WorkflowStepCompletion {
    id?: number;
    name: string;
    should_confirm?: boolean;
    allow_additional_files?: boolean;
    allow_additional_forms?: boolean;
    next_step_id?: number;
    next_step?: WorkflowStep;
    step_id?: number;
    step?: WorkflowStep;
    auto_emails?: WorkflowAutoEmail[];
    auto_uploads?: WorkflowAutoUpload[];
    auto_starts?: WorkflowAutoStart[];
    files: WorkflowFile[];
    forms?: WorkflowForm[];

    priority?: number;
    is_enabled_acceptance_criteria?: boolean;
    acceptance_method?: AcceptanceMethod;
    acceptance_percent?: number;
    acceptance_percent_type?: AcceptancePercentType;
    acceptance_people?: number;
    
    required_user_auths?: ConnectedAppAuth[];
}

export enum AcceptanceMethod {
    ACCEPTANCE_METHOD_PLURALITY = 1,
    ACCEPTANCE_METHOD_PERCENT = 2,
    ACCEPTANCE_METHOD_PEOPLE = 3
}

export enum AcceptancePercentType {
    ACCEPTANCE_PERCENT_TYPE_NOTIFIED = 1,
    ACCEPTANCE_PERCENT_TYPE_RESPONSES = 2
}
